export const PRIVACY_POLICY_CONTENT = `
## 1. Responsable del tratamiento

| Concepto | Dato |
| --- | --- |
| Responsable | Alejandro Serrano Notivoli |
| NIF | ES29133706C |
| Domicilio | C/ Felipe Sanclemente 8, 4B, 50001, Zaragoza, España |
| Correo electrónico | soporte@alejandrosn.com |
| Sitio web | https://blunticle.alejandrosn.com |

## 2. Ámbito de aplicación

Esta Política de Privacidad se aplica al tratamiento de datos personales realizado a través de Blunticle (https://blunticle.alejandrosn.com), incluyendo el registro de usuarios, la prestación del servicio, la facturación y la comunicación con el titular.

## 3. Datos que tratamos

Podemos tratar las siguientes categorías de datos:

- **Datos identificativos:** dirección de correo electrónico.
- **Datos de autenticación:** identificador de sesión (cookie JWT HttpOnly).
- **Datos de uso:** contenidos generados, campañas, créditos consumidos, preferencias de la cuenta.
- **Datos de facturación:** identificador de cliente en Stripe, historial de suscripciones y compras de créditos (gestionados por Stripe).
- **Datos técnicos:** dirección IP, tipo de navegador, páginas visitadas (solo si aceptas cookies analíticas).

No recopilamos categorías especiales de datos (salud, opiniones políticas, etc.) de forma intencionada.

## 4. Finalidades y base legal

| Finalidad | Base legal |
| --- | --- |
| Registro y autenticación (magic link por email) | Ejecución del contrato (art. 6.1.b RGPD) |
| Prestación del servicio de generación de contenido | Ejecución del contrato (art. 6.1.b RGPD) |
| Gestión de créditos, suscripciones y pagos | Ejecución del contrato (art. 6.1.b RGPD) |
| Comunicaciones transaccionales (confirmaciones de pago, avisos de servicio) | Ejecución del contrato / interés legítimo (art. 6.1.b y 6.1.f RGPD) |
| Soporte al usuario | Interés legítimo (art. 6.1.f RGPD) |
| Análisis estadístico del sitio (Google Analytics) | Consentimiento (art. 6.1.a RGPD) |
| Cumplimiento de obligaciones legales (fiscal, contable) | Obligación legal (art. 6.1.c RGPD) |

## 5. Destinatarios y encargados del tratamiento

Tus datos pueden ser comunicados a los siguientes proveedores, que actúan como encargados del tratamiento:

| Proveedor | Finalidad | Ubicación |
| --- | --- | --- |
| Cloudflare, Inc. | Hosting, CDN, Workers, base de datos D1 | EE. UU. / UE (con garantías adecuadas) |
| Stripe, Inc. | Procesamiento de pagos y suscripciones | EE. UU. / UE (con garantías adecuadas) |
| Resend, Inc. | Envío de correos transaccionales (magic link, facturación) | EE. UU. |
| Google LLC | Google Analytics (si consientes) y Google Fonts | EE. UU. / UE |

No vendemos ni cedemos tus datos a terceros con fines comerciales.

## 6. Transferencias internacionales

Algunos proveedores pueden tratar datos fuera del Espacio Económico Europeo. En esos casos, se aplican las garantías previstas en el RGPD (Cláusulas Contractuales Tipo de la Comisión Europea u otros mecanismos reconocidos).

## 7. Plazos de conservación

- **Datos de cuenta:** mientras mantengas la cuenta activa y, tras su cancelación, durante el plazo necesario para atender reclamaciones o obligaciones legales (máximo 5 años).
- **Datos de facturación:** 6 años (obligación fiscal).
- **Contenidos generados:** mientras mantengas la cuenta o hasta que los elimines.
- **Datos analíticos:** según la política de retención de Google Analytics (hasta 26 meses, configurable).
- **Logs técnicos:** máximo 12 meses.

## 8. Derechos del interesado

Puedes ejercer los siguientes derechos dirigiéndote a soporte@alejandrosn.com:

- **Acceso** a tus datos personales.
- **Rectificación** de datos inexactos.
- **Supresión** («derecho al olvido»), cuando proceda.
- **Limitación** del tratamiento.
- **Portabilidad** de los datos que nos hayas facilitado.
- **Oposición** al tratamiento basado en interés legítimo.
- **Retirar el consentimiento** en cualquier momento (sin efectos retroactivos).

También tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD): https://www.aepd.es

## 9. Seguridad

Aplicamos medidas técnicas y organizativas adecuadas para proteger tus datos, incluyendo:

- Autenticación mediante cookie JWT HttpOnly (no accesible desde JavaScript).
- Comunicaciones cifradas (HTTPS/TLS).
- Infraestructura en Cloudflare Edge con aislamiento por usuario.
- Pagos gestionados íntegramente por Stripe (no almacenamos datos de tarjeta).

## 10. Menores de edad

Blunticle no está dirigido a menores de 16 años. No recopilamos datos de menores de forma consciente. Si detectamos una cuenta de un menor, procederemos a su eliminación.
`;
